import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, createStyleSheet} from 'material-ui/styles'
import Input from 'material-ui/Input/Input'
import Card, {CardContent} from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import SearchIcon from 'material-ui-icons/Search'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import axios from 'axios'
import ToolTip from './tooltip'
import Syllabic from './syllabic'
import HtmlToReact from './html-to-react'
import WordsMenu from './words-menu'
import Player from './player'
import Conjugate from './conjudate'
import AutoComplete from './autocomplete'
import {server, title} from './constants'
import Label from "./label";


const styleSheet = createStyleSheet('TextInputs', theme => ({
    container: {
        flex: 1,
        flexDirection: 'column',
        marginTop: theme.spacing.unit * 3,
    },
    player:{
        marginLeft:117,
    },
    input: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    result: {
        marginTop: theme.spacing.unit * 3,

    },
    item: {
        marginBottom: theme.spacing.unit,
    },
    next_previous: {
        marginRight: theme.spacing.unit,
    },
    nextPrevious: {}

}));


const getSelected = () => {

    if (window.getSelection) {
        return window.getSelection();
    }
    else if (document.getSelection) {
        return document.getSelection();
    }
    else {
        let selection = document.selection && document.selection.createRange();
        if (selection.text) {
            return selection.text;
        }
    }
    return false;

};

const clearTextSelection = () => {
    if (document.selection) {
        document.selection.empty();
    } else if (window.getSelection) {
        window.getSelection().removeAllRanges();
    }
};

class FindItForm extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();

    }

    getInitialState = () => {
        return {
            Word: '',
            Pronunciation: '',
            Syllabic: [],
            Syn_syn: [],
            Syn_ant: [],
            Anagrams: [],
            Metaphone: [],
            Meaning: [],
            Plural: '',
            Verb: {},
            Previous: '',
            Next: '',
            noResult: false,
            word_input: '',
            autocomplete: true,
        };
    };

    updateState(data) {
        this.setState({
            Word: data.Word,
            Pronunciation: data.Pronunciation,
            Syllabic: data.Syllabic,
            Syn_syn: data.Syn_syn,
            Syn_ant: data.Syn_ant,
            Anagrams: data.Anagrams,
            Metaphone: data.Metaphone,
            Meaning: data.Meaning,
            Plural: data.Plural,
            Verb: data.Verb,
            Previous: data.Word_slug[0],
            Next: data.Word_slug[1],
            noResult: data.noResult,
            word_input: '',
            autocomplete: false,

        });

    }

    componentWillMount(){
        if( this.props.searchWord !==  undefined){
            this.getData(this.props.searchWord)
            document.title = title + ' Significado de : '+this.props.searchWord
        }else{
            document.title = title
        }
    }

    getData = (word) => {
        if (word === undefined) {
            return
        }

        let self = this;
        axios.get(server + 'dictionary-api/words/', {
            params: {
                find_it: word
            }
        })
            .then(function (response) {
                if (response.data.length > 0) {
                    self.updateState(response.data[0])
                } else {
                    /* ask for a meaning */
                }
            })
            .catch(function (error) {
                console.log(error)
            });
    };

    redirect(word){
        if (word !== undefined && word !== '') {
            window.location.href= '/'+word+'/'
        }
    }

    autoSuggestion = (word) => {
        this.redirect(word)
    };

    onSubmit = (e) => {
        e.preventDefault()
        this.redirect(this.state.word_input)
    };

    onMouseUp = () => {

        let selection = getSelected();
        selection = selection && String(selection).replace(/^\s+|\s+$/g, '')
        if (selection) {
            clearTextSelection();
            this.getData(selection)
        }
    };

    onChange = (e) => {
        this.setState({word_input: e.target.value, autocomplete: true});
    };

    menuWordChange = (word) => {
        this.redirect(word)
    };

    prevButtonOnClick = () => {
        this.redirect(this.state.Previous)
    };

    nextButtonOnClick = () => {
        this.redirect(this.state.Next)
    };

    render() {
        const classes = this.props.classes;

        return (
            <div className={classes.container}>
                <form  onSubmit={this.onSubmit}>

                    <Input type="search"
                           className={classes.input}
                           placeholder="Palavra"
                           value={this.state.word_input}
                           onChange={this.onChange}
                           autoComplete="none"

                    />
                    <IconButton
                        type="submit"
                        className={classes.button}>
                        <SearchIcon/>
                    </IconButton>
                    <AutoComplete
                        value={this.state.word_input}
                        listen={this.state.autocomplete}
                        callback={this.autoSuggestion}/>
                </form>

                <Card className={classes.result}>
                    <CardContent>
                        <Player text={this.state.Word} lang="br" accent="Pronuncia Brasileira"/>
                        <Player text={this.state.Word} lang="pt" accent="Pronuncia Portuguesa"/>

                        {<Syllabic syllabic={this.state.Syllabic}/>}
                        <Label title="Plural: " content={this.state.Plural}/>
                        <Label title="Significado de: " content={this.state.Word}/>


                        {this.state.Meaning.map((mean, index) => (
                            <Typography key={index}
                                        component="span"
                                        className={classes.item}
                                        onMouseUp={this.onMouseUp}>

                                {index + 1}) <HtmlToReact tag="i" before={true} html={mean[1]}/>

                                <Typography component="span">
                                    <ToolTip keyAbbr={mean[0]}/>
                                </Typography>
                            </Typography>
                        ))
                        }

                    </CardContent>
                    <CardContent>

                        <Button className={classes.next_previous}
                                title={this.state.Previous}
                                onClick={this.prevButtonOnClick}>
                            {this.state.Previous}

                        </Button>

                        <Button className={classes.next_previous} disabled>
                            {this.state.Word}
                        </Button>

                        <Button
                            className={classes.next_previous}
                            onClick={this.nextButtonOnClick}
                            title={this.state.Next}>

                            {this.state.Next}
                        </Button>

                    </CardContent>
                    <WordsMenu menuName="Sinônimos" menuItems={this.state.Syn_syn} word={this.menuWordChange}/>
                    <WordsMenu menuName="Antônimos" menuItems={this.state.Syn_ant} word={this.menuWordChange}/>
                    <WordsMenu menuName="Anagramas" menuItems={this.state.Anagrams} word={this.menuWordChange}/>
                    <WordsMenu menuName="Soam parecido" menuItems={this.state.Metaphone} word={this.menuWordChange}/>
                    <Conjugate verb={this.state.Verb}/>
                </Card>

            </div>

        )
    }
}

FindItForm.propTypes = {
    classes: PropTypes.object.isRequired,
    searchWord: PropTypes.string
};

export default withStyles(styleSheet)(FindItForm);


// WEBPACK FOOTER //
// ./src/portuguese.jsx